import * as yup from 'yup';

import { endpoint, EndpointError } from 'endpoints/endpoint';
import { isValidUUID } from 'utils/is-valid-uuid';

import { ValidationShape, ERROR as VALIDATION_ERROR } from '../validation';

export type GetTokenParams = {
  canPublishTracks: boolean;
  userId: string;
  roomId: string;
};
export type GetTokenResult = { token: string };
export type GetTokenError = EndpointError;

export const getTokenParamsSchema = yup.object().shape({
  canPublishTracks: yup.boolean().required(VALIDATION_ERROR.REQUIRED),
  userId: yup
    .string()
    .test('format', VALIDATION_ERROR.INVALID_FORMAT, (value) => {
      if (value?.length === 28) {
        return true;
      }

      return isValidUUID(value || '');
    })
    .required(VALIDATION_ERROR.REQUIRED),
  roomId: yup.string().required(VALIDATION_ERROR.REQUIRED),
} as ValidationShape<GetTokenParams>);

export const getToken = endpoint<GetTokenParams, GetTokenResult, GetTokenError>({
  method: 'POST',
  url: () => '/live-kit/get-participant-token',
});
